export default __webpack_public_path__ + "5cb5438ccf50bbd4d44050b1a3337b0d.png";